const PREFIX = 'dq_dash_v1:';
export const DASHBOARD_CACHE_MAX_AGE_MS = 6 * 60 * 60 * 1000;

function storage() {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
}

function serializePart(value) {
  if (value == null) return '';
  if (Array.isArray(value)) return value.map(String).sort().join(',');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

export function dashboardCacheKey(scope, user, extra = {}) {
  const parts = {
    s: scope || '',
    u: user?.user_id || '',
    c: user?.company_id ?? '',
    ...extra,
  };
  return PREFIX + Object.keys(parts)
    .sort()
    .map((key) => `${key}=${serializePart(parts[key])}`)
    .join('|');
}

export function readDashboardCache(key) {
  const store = storage();
  if (!store || !key) return null;
  try {
    const raw = store.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const savedAt = Number(parsed.savedAt || 0);
    if (!savedAt || Date.now() - savedAt > DASHBOARD_CACHE_MAX_AGE_MS) {
      store.removeItem(key);
      return null;
    }
    return parsed.data ?? null;
  } catch {
    return null;
  }
}

export function writeDashboardCache(key, data) {
  const store = storage();
  if (!store || !key || data == null) return;
  const payload = JSON.stringify({ savedAt: Date.now(), data });
  try {
    store.setItem(key, payload);
  } catch {
    clearDashboardCache();
    try {
      store.setItem(key, payload);
    } catch {
      /* quota */
    }
  }
}

export function clearDashboardCache() {
  const store = storage();
  if (!store) return;
  const toRemove = [];
  for (let i = 0; i < store.length; i += 1) {
    const key = store.key(i);
    if (key && key.startsWith(PREFIX)) toRemove.push(key);
  }
  toRemove.forEach((key) => store.removeItem(key));
}
